module.exports = __webpack_public_path__ + "static/media/img113_R.b17775d9.jpg";